var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('activity-redirect-item',{attrs:{"loan-tasks":_vm.tasks,"current-loan-task":_vm.currentTaskName,"is-loan-task":true,"redirect-activity":_vm.redirectActivity}}),_c('bureau-details-provider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }